/**
 * Regla de alcance de compañía para producto, en el cliente.
 *
 * Espejo del backend `ProductScopeRules.IsSelectableForSale` (crm-core): un producto con
 * `companyId = null` es válido para todas las compañías. Este filtro es un fallback de
 * pre-carga para los 3 pickers que aún leen la caché global mientras `lineOptions` no ha
 * llegado del servidor; nunca debe inventar una segunda regla.
 */
export interface ProductCompanyScopeCandidate {
  companyId?: number | null;
  company?: { id?: number | null } | null;
}

export function isProductInCompanyScope(
  product: ProductCompanyScopeCandidate | null | undefined,
  companyId: number | null | undefined,
): boolean {
  if (!product) {
    return false;
  }

  return (
    // Solo un companyId explícitamente null significa "global" (el sentinel del backend). Un
    // companyId ausente (undefined) no es lo mismo: cae al fallback de company?.id, igual que
    // antes de este cambio, para no tratar como global un producto simplemente mal formado.
    product.companyId === null ||
    product.companyId === companyId ||
    product.company?.id === companyId
  );
}
